import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import Textarea from "../components/Textarea";
import { getSplitData, pause, uploadData } from "../service/tabDetail.service";
import stringToArray from "../utils/stringToArray";

const API_BASE = process.env.REACT_APP_BACKEND_URL;

const TabDetail = () => {
  const { tab } = useParams();
  const [fileInputKeyCustomer, setFileInputKeyCustomer] = useState(Date.now());
  const [fileInputKeyAdmin, setFileInputKeyAdmin] = useState(Date.now());
  const [emailListCustomer, setEmailListCustomer] = useState([]);
  const [emailListAdmin, setEmailListAdmin] = useState([]);
  const [emailContent, setEmailContent] = useState("");
  const [emailSubject, setEmailSubject] = useState("");
  const [emailNameDisplay, setEmailNameDisplay] = useState("");
  const [links, setLinks] = useState("");
  const [limit, setLimit] = useState("200");
  const [startIndex, setStartIndex] = useState("");
  const [logs, setLogs] = useState([]);
  const logContainerRef = useRef(null);
  const [fileNameCustomer, setFileNameCustomer] = useState("");
  const [fileNameAdmin, setFileNameAdmin] = useState("");
  const [emailCheck, setEmailCheck] = useState("yen464764@gmail.com");
  const wsRef = useRef(null);

  // Load chunk data on mount
  useEffect(() => {
    document.title = `Tab: ${tab.replace(/\D/g, "")}`;
    getSplit(tab);
  }, [tab]);

  const getSplit = async (tab) => {
    try {
      console.log("🔄 Loading chunk data for tab:", tab);

      const response = await getSplitData(tab);
      console.log("✅ Loaded chunk data", response);
      const { admin, customer, nameDisplays, subjects, links, content } =
        response;

      setEmailListAdmin(admin.map((a) => ({ ...a, status: "" })));
      setEmailListCustomer(customer.map((c) => ({ ...c, status: "" })));
      setEmailNameDisplay(nameDisplays.join("\n"));
      setEmailSubject(subjects.join("\n"));
      setLinks(links.join("\n"));
      setEmailContent(Array.isArray(content) ? content.join("\n") : content);
    } catch (err) {
      console.error("Failed to load chunk data", err);
    }
  };

  useEffect(() => {
    const host = API_BASE.replace(/^https?:\/\//, "");
    const protocol = window.location.protocol === "https:" ? "wss" : "ws";
    const wsUrl = `${protocol}://${host}/ws`;

    const ws = new WebSocket(wsUrl);
    wsRef.current = ws;

    ws.addEventListener("open", () => console.log("✅ WebSocket connected"));
    ws.addEventListener("error", (err) =>
      console.error("WebSocket error", err)
    );
    ws.addEventListener("close", (evt) =>
      console.log("🔒 WebSocket closed", evt.code, evt.reason)
    );

    ws.addEventListener("open", () =>
      ws.send(JSON.stringify({ type: "subscribe", tab }))
    );

    ws.addEventListener("message", (evt) => {
      let payload;
      try {
        payload = JSON.parse(evt.data);
      } catch {
        return;
      }
      console.log("📬 Received message:", payload);

      setLogs((prev) => [...prev, payload]);

      // cập nhật trạng thái admin
      if (payload.admin) {
        setEmailListAdmin((prev) =>
          prev.map((item) =>
            item.email === payload.admin.email
              ? {
                  ...item,
                  status: payload.admin.status,
                  error: payload.admin.error,
                }
              : item
          )
        );
      }

      // cập nhật trạng thái customer
      if (payload.customer) {
        setEmailListCustomer((prev) =>
          prev.map((item, idx) =>
            idx === payload.customer.id
              ? { ...item, status: payload.status }
              : item
          )
        );
      }

      if (payload.customerNotSent) {
        setEmailListCustomer(payload.customerNotSent);
      }
    });

    return () => ws.close();
  }, [tab]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (logContainerRef.current) {
        logContainerRef.current.scrollTop =
          logContainerRef.current.scrollHeight;
      }
    }, 100);

    return () => clearTimeout(timeout);
  }, [logs]);

  const handleFileChange = async (e, type) => {
    try {
      const file = e.target.files[0];
      if (!file) return;

      if (type === "customer") {
        setFileNameCustomer(file.name);
        setFileInputKeyCustomer(Date.now()); // reset key để cho phép chọn lại
      } else if (type === "admin") {
        setFileNameAdmin(file.name);
        setFileInputKeyAdmin(Date.now()); // reset key để cho phép chọn lại
      }

      const response = await uploadData(type, tab, file);

      if (type === "customer") {
        setEmailListCustomer(response.data);
      } else if (type === "admin") {
        setEmailListAdmin(response.data);
      }

      console.log("✅ File uploaded successfully", response.data);
    } catch (err) {
      console.error("❌ Failed to load email list", err);
    }
  };

  const startSendingEmails = async () => {
    try {
      wsRef.current.send(
        JSON.stringify({
          type: "start-sending",
          tab,
          templateHtmls: emailContent
            .split("<!-- TEMPLATE-HTML -->")
            .map((s) => s.trim())
            .filter(Boolean),
          subjects: emailSubject
            .split("\n")
            .map((s) => s.trim())
            .filter(Boolean),
          nameDisplays: emailNameDisplay
            .split("\n")
            .map((s) => s.trim())
            .filter(Boolean),
          links: links
            .split("\n")
            .map((s) => s.trim())
            .filter(Boolean),
          limit: limit ? Number(limit) : undefined,
          startIndex: startIndex ? Number(startIndex) : undefined,
        })
      );
    } catch (error) {
      console.error("❌ Failed to send emails", error);
    }
  };

  const startCheckingEmails = async () => {
    try {
      wsRef.current.send(
        JSON.stringify({
          type: "start-checking",
          tab,
          templateHtmls: emailContent
            .split("<!-- TEMPLATE-HTML -->")
            .map((s) => s.trim())
            .filter(Boolean),
          subjects: emailSubject
            .split("\n")
            .map((s) => s.trim())
            .filter(Boolean),
          nameDisplays: emailNameDisplay
            .split("\n")
            .map((s) => s.trim())
            .filter(Boolean),
          links: links
            .split("\n")
            .map((s) => s.trim())
            .filter(Boolean),
          checkTo: emailCheck,
        })
      );
    } catch (error) {
      console.error("❌ Failed to checking mail", error);
    }
  };

  const startCheckingNewEmails = async () => {
    try {
      wsRef.current.send(
        JSON.stringify({
          type: "start-checking-new-admin",
          tab,
          templateHtmls: emailContent
            .split("<!-- TEMPLATE-HTML -->")
            .map((s) => s.trim())
            .filter(Boolean),
          subjects: emailSubject
            .split("\n")
            .map((s) => s.trim())
            .filter(Boolean),
          nameDisplays: emailNameDisplay
            .split("\n")
            .map((s) => s.trim())
            .filter(Boolean),
          links: links
            .split("\n")
            .map((s) => s.trim())
            .filter(Boolean),
          checkTo: emailCheck,
        })
      );
    } catch (error) {
      console.error("❌ Failed to checking mail new admin", error);
    }
  };

  const readFilesAsText = (files) => {
    return new Promise((resolve, reject) => {
      const fileArray = Array.from(files || []);
      if (fileArray.length === 0) {
        return reject("Không có file nào được chọn");
      }

      // Tạo một Promise cho mỗi FileReader
      const readPromises = fileArray.map((file) => {
        return new Promise((res, rej) => {
          const reader = new FileReader();

          reader.onload = (event) => {
            res(event.target.result);
          };
          reader.onerror = (error) => {
            rej(`Lỗi khi đọc file "${file.name}": ${error.message}`);
          };

          reader.readAsText(file);
        });
      });

      // Chờ tất cả xong, rồi join với delimiter
      Promise.all(readPromises)
        .then((contents) => {
          const combined = contents.join("<!-- TEMPLATE-HTML -->\n");
          resolve(combined);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  const handleTemplateFileChange = async (e) => {
    const files = e.target.files;
    if (!files) return;

    try {
      const content = await readFilesAsText(files);
      setEmailContent(content);
    } catch (err) {
      console.error("❌ Lỗi khi đọc file mẫu:", err);
    }
  };

  const pauseSending = async () => {
    try {
      await pause(tab);
    } catch (error) {
      console.error("❌ Lỗi khi tạm dừng:", error);
    }
  };

  const checkMailStatus = async () => {
    try {
      wsRef.current.send(
        JSON.stringify({
          type: "check-mail-admin",
          tab,
        })
      );
    } catch (error) {
      console.error("❌ Failed to check mail status", error);
    }
  };

  const handleDelete = async () => {
    const confirm = window.confirm(
      "Bạn có chắc muốn xoá tất cả email đã gửi thành công?"
    );
    if (!confirm) return;

    try {
      wsRef.current.send(
        JSON.stringify({
          type: "remove-sent-customers",
          tab,
        })
      );
    } catch (err) {
      console.error("❌ Failed to delete email list", err);
    }
  };

  return (
    <div className="h-screen bg-gray-100 flex items-center justify-center p-4 gap-6 overflow-y-auto">
      <div className="h-full w-full sm:w-1/2 md:w-1/2 lg:w-1/2 flex flex-col items-start bg-white shadow-lg rounded-lg p-6 gap-6">
        {/* Danh sách khách hàng */}
        <div className="w-full h-3/5 flex flex-col ">
          <h1 className="text-2xl font-semibold mb-4 text-gray-800">
            Danh sách khách hàng
          </h1>
          <div className="grid grid-cols-2 gap-4">
            <input
              key={fileInputKeyCustomer}
              className="block w-full text-sm mb-2 text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 focus:outline-none"
              type="file"
              onChange={(e) => handleFileChange(e, "customer")}
            />
            <div className="flex flex-col">
              <input
                placeholder="Nhập email check"
                value={emailCheck}
                onChange={(e) => setEmailCheck(e.target.value)}
                className="p-1 resize-none text-sm text-gray-900 border border-gray-300 rounded focus:outline-none"
              />
            </div>
          </div>
          {fileNameCustomer && (
            <p className="text-sm text-gray-600 mb-2 font-bold">
              Tên file: {fileNameCustomer}
            </p>
          )}
          <div className="h-full overflow-x-auto rounded-lg shadow-md bg-gray-50">
            <table className="min-w-full table-auto border-collapse">
              <thead>
                <tr className="bg-gray-200">
                  <th className="px-4 py-2 text-left font-semibold text-gray-700">
                    STT
                  </th>
                  <th className="px-4 py-2 text-left font-semibold text-gray-700">
                    Tên page
                  </th>
                  <th className="px-4 py-2 text-left font-semibold text-gray-700">
                    Email
                  </th>
                  <th className="px-4 py-2 text-left font-semibold text-gray-700">
                    Trạng thái
                  </th>
                </tr>
              </thead>
              <tbody className="overflow-y-auto ">
                {emailListCustomer?.map((item, index) => (
                  <tr key={index} className="border-t">
                    <td className="px-4 py-2">{index + 1}</td>
                    <td className="px-4 py-2">{item.name}</td>
                    <td className="px-4 py-2">{item.email}</td>
                    <td className="px-4 py-2">
                      <span
                        className={`px-3 py-1 whitespace-nowrap rounded-full text-sm font-medium ${
                          item.status === "success"
                            ? "bg-green-200 text-green-700"
                            : item.status === "error"
                            ? "bg-red-200 text-red-700"
                            : "bg-gray-200 text-gray-700"
                        }`}
                      >
                        {item.status === "success" && "✅ Thành công"}
                        {item.status === "error" && "❌ Lỗi"}
                        {!item.status && "⏳ Chờ gửi"}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Danh sách mail admin */}
        <div className="w-full h-2/5 flex flex-col">
          <div className="flex items-center justify-between w-full mb-4">
            <h1 className="text-2xl font-semibold  text-gray-800">
              Danh sách mail admin
            </h1>
            <button
              onClick={checkMailStatus}
              className="bg-green-500 text-white px-5 py-1 rounded-lg hover:bg-green-600 font-semibold"
            >
              Kiểm tra
            </button>
          </div>
          <input
            key={fileInputKeyAdmin}
            className="block mb-2 text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 focus:outline-none"
            type="file"
            onChange={(e) => handleFileChange(e, "admin")}
          />
          {fileNameAdmin && (
            <p className="text-sm text-gray-600 mb-2 font-bold">
              Tên file: {fileNameAdmin}
            </p>
          )}
          <div className="h-full overflow-x-auto rounded-lg shadow-md bg-gray-50">
            <table className="min-w-full table-auto border-collapse">
              <thead>
                <tr className="bg-gray-200">
                  <th className="px-4 py-2 text-left font-semibold text-gray-700">
                    STT
                  </th>
                  <th className="px-4 py-2 text-left font-semibold text-gray-700">
                    Email
                  </th>
                  <th className="px-4 py-2 text-left font-semibold text-gray-700">
                    Password
                  </th>
                  <th className="px-4 py-2 text-left font-semibold text-gray-700">
                    Status
                  </th>
                  <th className="px-4 py-2 text-left font-semibold text-gray-700">
                    Proxy
                  </th>
                  <th className="px-4 py-2 text-left font-semibold text-gray-700">
                    Host
                  </th>
                  <th className="px-4 py-2 text-left font-semibold text-gray-700">
                    Port
                  </th>
                </tr>
              </thead>
              <tbody className="overflow-y-auto">
                {emailListAdmin?.map((item, index) => (
                  <tr key={index} className="border-t">
                    <td className="px-4 py-2 whitespace-nowrap">{index + 1}</td>
                    <td className="px-4 py-2 whitespace-nowrap">
                      {item.email}
                    </td>
                    <td className="px-4 py-2 whitespace-nowrap">
                      {item.password}
                    </td>
                    <td className="px-4 py-2 whitespace-nowrap">
                      <span
                        className={`px-3 py-1 whitespace-nowrap rounded-full text-sm font-medium ${
                          item?.status === "success" || item?.status === "used"
                            ? "bg-green-200 text-green-700"
                            : item?.status === "error"
                            ? "bg-red-200 text-red-700"
                            : "bg-gray-200 text-gray-700"
                        }`}
                      >
                        {item?.status === "success" && "✅ Hợp lệ"}
                        {item?.status === "used" && "📩 Đã dùng"}
                        {item?.status === "error" && (
                          <>
                            {item?.error?.status === "die" && "💀 Die"}
                            {item?.error?.status === "limit" && "⌛ Đạt giới"}
                            {item?.error?.status === "connect" &&
                              "🔌 Mất kết nối"}
                            {item?.error?.status === "proxy" && "🛡️ Lỗi proxy"}
                            {item?.error?.status === "lock" && "🔒 Bị khóa"}
                            {!item?.error?.status && "❌ Chưa xác định"}
                          </>
                        )}

                        {!item?.status && "⏳ Chưa kiểm tra"}
                      </span>
                    </td>

                    <td className="px-4 py-2  whitespace-nowrap">
                      {item.proxy}
                    </td>
                    <td className="px-4 py-2  whitespace-nowrap">
                      {item.host}
                    </td>
                    <td className="px-4 py-2  whitespace-nowrap">
                      {item.port}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div className="h-full w-full sm:w-1/2 md:w-1/2 lg:w-1/2 flex flex-col items-center bg-white shadow-lg rounded-lg p-5">
        {/* Nội dung thư */}
        <div className="w-full flex-1 mb-3 flex flex-col">
          <div className="flex-1 mb-2">
            <h1 className="text-2xl font-semibold mb-4 text-gray-800">
              Nội dung thư
            </h1>
            <input
              type="file"
              accept=".txt,.html"
              multiple
              onChange={handleTemplateFileChange}
              className="block w-full text-sm mb-2 text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 focus:outline-none"
            />
            <textarea
              value={emailContent}
              onChange={(e) => setEmailContent(e.target.value)}
              className="w-full h-full max-h-44 resize-none p-3 text-gray-900 border border-gray-300 rounded-lg focus:outline-none"
              placeholder="Nội dung thư"
            />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <Textarea
              label={`Tên hiển thị (Đang có: ${
                stringToArray(emailNameDisplay).length
              })`}
              value={emailNameDisplay}
              onChange={(e) => setEmailNameDisplay(e.target.value)}
              placeholder="Nhập nhiều tên, mỗi tên 1 dòng"
            />
            <Textarea
              label={`Link trang web (Đang có: ${stringToArray(links).length})`}
              value={links}
              onChange={(e) => setLinks(e.target.value)}
              placeholder="Nhập nhiều link, mỗi link 1 dòng"
            />
          </div>

          <div className="grid grid-cols-2 gap-4 mt-2">
            {/* Cột trái: Tiêu đề mail */}

            <div className="flex flex-col h-full">
              <label className="text-sm font-semibold text-gray-800 mb-1">
                Tiêu đề mail (Đang có: {stringToArray(emailSubject).length})
              </label>
              <textarea
                placeholder="Nhập nhiều tiêu đề, mỗi tiêu đề 1 dòng"
                value={emailSubject}
                onChange={(e) => setEmailSubject(e.target.value)}
                className="p-2 resize-none text-sm text-gray-900 border border-gray-300 rounded focus:outline-none flex-1"
              />
            </div>

            {/* Cột phải: Vị trí bắt đầu gửi & Giới hạn gửi */}
            <div className="flex flex-col justify-between h-full">
              <div className="flex flex-col mb-2">
                <label className="text-sm font-semibold text-gray-800 mb-1">
                  Vị trí bắt đầu gửi:
                </label>
                <input
                  placeholder="Mặc định từ 1"
                  type="number"
                  value={startIndex}
                  onChange={(e) => setStartIndex(e.target.value)}
                  className="p-2 text-sm text-gray-900 border border-gray-300 rounded focus:outline-none"
                />
              </div>
              <div className="flex flex-col">
                <label className="text-sm font-semibold text-gray-800 mb-1">
                  Giới hạn gửi:
                </label>
                <input
                  placeholder="Mặc định 300"
                  type="number"
                  value={limit}
                  onChange={(e) => setLimit(e.target.value)}
                  className="p-2 text-sm text-gray-900 border border-gray-300 rounded focus:outline-none"
                />
              </div>
            </div>
          </div>

          <div className="flex gap-2 mt-4">
            <button
              onClick={startSendingEmails}
              className="bg-green-500 hover:bg-green-600 text-white font-semibold px-5 py-1 rounded-lg shadow transition duration-200"
            >
              Start
            </button>
            <button
              onClick={pauseSending}
              className="bg-violet-500 hover:bg-violet-600 text-white font-semibold px-5 py-1 rounded-lg shadow transition duration-200"
            >
              Stop
            </button>
            <button
              onClick={startCheckingEmails}
              className="bg-emerald-500 hover:bg-emerald-600 text-white font-semibold px-5 py-1 rounded-lg shadow transition duration-200"
            >
              Check
            </button>
            <button
              onClick={startCheckingNewEmails}
              className="bg-emerald-500 hover:bg-emerald-600 text-white font-semibold px-5 py-1 rounded-lg shadow transition duration-200"
            >
              Check New Admin
            </button>
            <button
              onClick={handleDelete}
              className="bg-red-500 hover:bg-red-600 text-white font-semibold px-5 py-1 rounded-lg shadow transition duration-200"
            >
              Delete Mail Sent
            </button>
          </div>
        </div>

        {/* Trạng thái */}
        <div className="h-2/6 w-full flex flex-col bg-white">
          <h1 className="text-2xl font-semibold mb-4 text-gray-800 w-full text-start">
            Trạng thái
          </h1>

          <div
            className="border w-full flex-1 overflow-y-auto bg-gray-100 p-4 rounded-lg shadow-md"
            ref={logContainerRef}
          >
            <div className="space-y-2">
              {logs.map((log, index) => (
                <div key={index} className="text-sm">
                  {log.status === "success" && (
                    <p className="text-green-600 font-semibold">
                      {log.message}
                    </p>
                  )}
                  {log.status === "error" && (
                    <p className="text-red-500 font-semibold">
                      {log.error.message}
                    </p>
                  )}
                  {log.status === "info" && (
                    <p className="text-gray-600 font-semibold">{log.message}</p>
                  )}
                  {log.status === "done" && (
                    <p className="text-blue-600 font-semibold">{log.message}</p>
                  )}
                  {log.status === "warning" && (
                    <p className="text-yellow-600 font-semibold">
                      {log.message}
                    </p>
                  )}
                  {log.status === "fatal" && (
                    <p className="text-red-700 font-semibold">{log.message}</p>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TabDetail;
